import { render, staticRenderFns } from "./MergeContacts.vue?vue&type=template&id=6d56a4bc&scoped=true"
import script from "./MergeContacts.vue?vue&type=script&lang=js"
export * from "./MergeContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d56a4bc",
  null
  
)

export default component.exports